angular.module('tgaAdmin').controller('LoginController', [
  '$scope',
  '$state',
  '$location',
  'userService',
  'settingsService',
  'domainService',
  '$uibModal',
  function ($scope, $state, $location, userService, settingsService, domainService, $uibModal) {
    $scope.checkingCookie = true;

    if (userService.isLoggedIn()) {
      $state.go('v1.games');
      return;
    }
    $scope.checkingCookie = false;

    $scope.data = {
      alerts: [],
      logo: '',
      defaultLogo: './v1/assets/images/logo-black.svg',
    };

    $scope.viewmodel = {
      username: '',
      password: '',
      remember: false,
      token: $location.search().sessionToken,
      deviceToken: '',
    };

    $scope.initialize = function () {
      $scope.checkingSSO = true;

      domainService.checkSSO().then((response) => {
        if (response.sso) {
          $scope.isSSO = true;
          $scope.redirect = response.redirect;
        }

        if ($scope.viewmodel.token) {
          userService.login($scope.viewmodel).then(
            () => {
              $state.go('v1.games');
            },
            (err) => {
              $scope.checkingSSO = false;
              $scope.actions.createAlert(err.message, 'danger');
            },
          );
        } else {
          $scope.checkingSSO = false;
        }
      });

      settingsService.getSettings().then((settings) => {
        $scope.data.logo = settings.logo || $scope.data.defaultLogo;
      });
    };

    $scope.actions = {
      submit() {
        $scope.data.alerts = [];

        if ($scope.loginForm.$invalid) {
          return;
        }

        $scope.loading = true;

        userService.login($scope.viewmodel).then(
          () => {
            if (userService.isTwoFactor() && !userService.twoFactorRememberEnabled()) {
              $scope.loading = false;
              $state.go('v1.login-two-factor');
            } else if (domainService.isDomainLoggingRequired(userService.getUserData(), domainService.domain)) {
              $scope.actions.domainLoggingModal();
            } else {
              $scope.loading = false;
              $state.go('v1.games');
            }
          },
          () => {
            $scope.loading = false;
            $scope.actions.createAlert('Invalid username or password.', 'danger');
          },
        );
      },
      domainLoggingModal() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-domain-logging.html',
            controller: 'DomainLoggingController',
            backdrop: true,
            size: 'lg',
            resolve: {
              desiredDomain: () => domainService.domain,
              externalLogin: () => true,
            },
          })
          .result.then((reason) => {
            const { submitted } = reason;
            $scope.loading = false;
            if (submitted) {
              $state.go('v1.games');
            }
          })
          .catch(() => {
            userService.logout();
            $scope.loading = false;
          });
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
